import createAxiosInstance from './axiosConfig';
import { Banco } from '../shared/model/banco';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/bancoController');

export default class BancoService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async listarTodosBancos() {
    return await this.axios.get(`/listarTodosBancos`);
  };

  async listarBancosCompraDivida() {
    return await this.axios.get(`/listarBancosCompraDivida`);
  };

  async listarBancoPorId(id: string) {
    return await this.axios.get(`/listarBancoPorId?id=${id}`);
  };

  async verificaBancoDigital(numero: string) {
    return await this.axios.get(`/verificaBancoDigital?numeroBanco=${numero}`);
  };

  async incluirAlterarBanco(dto: Banco) {
    return await this.axios.post(`/incluirAlterarBanco`, dto);
  };

}